<template>
  <div>
    <TheHeaderGrid title="アンケート" />
    <TemplateSurvey
      v-if="masterSurvey"
      :master-survey="masterSurvey"
      :terms-url="userInfoAcquisitionTermsUrl"
      :backend-validation-error="hasBackendValidationError"
      @submit="onSurveySubmit"
    />
    <DialogLoading ref="dialogLoading" />
    <DialogError
      ref="dialogError"
      error-title="エラーが発生しました。"
      error-sub-title="もう一度お試しください。"
      :action="() => nativeHandlerService.returnNativeAppTopPage()"
    />
  </div>
</template>

<script>
import { useSurveyPage } from "@/composables/useSurveyPage";
import TheHeaderGrid from "@/views/Components/Organisms/Common/TheHeaderGrid.vue";
import TemplateSurvey from "@/views/Templates/TicketStore/TemplateSurvey.vue";
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading.vue";
import DialogError from "@/views/Components/Organisms/Common/Dialog/DialogError.vue";

export default {
  name: "Survey",
  components: { TheHeaderGrid, TemplateSurvey, DialogLoading, DialogError },
  setup() {
    return useSurveyPage();
  },
};
</script>
